import React from 'react';
import {cn} from '@utils';
import {Image} from '@/components-v2';

interface HomeFloorBoxProps {
  name: string;
  id: string;
  gameType: string;
  hasMore?: boolean;
  shown?: boolean;
  className?: string;
  headerClassName?: string;
  bodyClassName?: string;
  iconClassName?: string;
  titleClassName?: string;
  rightNodeWrapClassName?: string;
  bg?: string;
  icon?: string;
  categoryPic?: string;
  titleExtraNode?: React.ReactNode;
  children: React.ReactNode;
  rightNode?: React.ReactNode;
  childrenWrapClassName?: string;
}

const BACKGROUND_IMAGES = {
  dice: require('../../assets/header-bg/dice.webp'),
  car: require('../../assets/header-bg/car.webp'),
  '3d': require('../../assets/header-bg/3d.webp'),
  kerala: require('../../assets/header-bg/kerala.webp'),
  color: require('../../assets/header-bg/color.webp'),
  satta: require('../../assets/header-bg/satta.webp'),
  casino: require('../../assets/header-bg/casino.webp'),
  scratch: require('../../assets/header-bg/scratch.webp'),
  live: require('../../assets/header-bg/live.webp'),
  mixLotto: require('../../assets/header-bg/3d.webp'),
  pick11: require('../../assets/header-bg/3d.webp'),
  sports: require('../../assets/header-bg/car.webp'),
} as {[key: string]: string};

const floorTitleStyle = {
  backgroundSize: '100% 100%, cover',
  backgroundRepeat: 'no-repeat',
};

const FLOOR_ICON = {
  car: require('../../assets/floor/car.webp'),
  dice: require('../../assets/floor/dice.webp'),
  '3d': require('../../assets/floor/3d.webp'),
  kerala: require('../../assets/floor/kerala.webp'),
  color: require('../../assets/floor/color.webp'),
  satta: require('../../assets/floor/satta.webp'),
  casino: require('../../assets/floor/casino.webp'),
  scratch: require('../../assets/floor/scratch.webp'),
  live: require('../../assets/floor/live.webp'),
  mixLotto:
    'https://lottery-india-resource.oss-accelerate.aliyuncs.com/manager/fcf4ba8223da4230896e62726d537539.webp',
  pick11: '/images/home/pick_logo.webp',
} as {[key: string]: string};

const HomeFloorBox = ({
  name,
  id,
  className,
  headerClassName,
  bodyClassName,
  iconClassName,
  titleClassName,
  rightNodeWrapClassName,
  bg,
  icon,
  categoryPic,
  gameType = '',
  children,
  rightNode,
  titleExtraNode,
  childrenWrapClassName,
}: HomeFloorBoxProps) => {
  const iconSrc = icon || categoryPic || FLOOR_ICON[gameType];
  const bgSrc = bg || BACKGROUND_IMAGES[gameType];

  return (
    <div className={cn('flex flex-col', className)} id={id}>
      <div
        className={cn(
          'px-3 flex w-full h-12 items-center bg-no-repeat bg-cover rounded-t-[1rem]',
          headerClassName,
        )}
        style={{
          ...floorTitleStyle,
          backgroundImage: `url(${bgSrc})`,
        }}>
        <Image
          lazy
          alt={gameType}
          src={iconSrc}
          className={cn(
            'w-[1.75rem] h-[1.75rem] object-contain',
            iconClassName,
          )}
        />
        <p className={cn('text-sm ml-3 font-bold', titleClassName)}>{name}</p>
        {titleExtraNode}
        <div className={cn('flex-1 flex justify-end', rightNodeWrapClassName)}>
          {rightNode}
        </div>
      </div>
      <div
        className={cn(
          'flex flex-wrap p-3 pt-0 gap-2',
          childrenWrapClassName,
          bodyClassName,
        )}>
        {children}
      </div>
    </div>
  );
};

export default HomeFloorBox;
